import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { FeatureTypeEnum, MenuTypeEnum } from '@/api/hanly/hanlyAPI.schemas';
import type { featureFlagType } from '@/types/feature-flag';
import type { menuVisibilityType } from '@/types/menu-visibility';

export interface AuthContextType {
  isAuthenticated: boolean;
  isAdmin: boolean;
  orgId: number;
  featureFlags: featureFlagType[];
  menuVisibilitySettings: menuVisibilityType[];
  setAuthInfo?: Dispatch<SetStateAction<AuthContextType>>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

/**
 * 指定された機能フラグが有効かどうかを判定
 */
export const isFeatureEnabled = (
  featureFlags: readonly featureFlagType[],
  featureType: FeatureTypeEnum,
): boolean => {
  return featureFlags.some((flag) => flag.featureType === featureType && flag.isEnabled);
};

/**
 * 指定されたメニューが非表示設定されているかを判定
 * デフォルトは表示（設定が無い、または is_hidden=false なら表示）
 */
export const isMenuHidden = (
  menuVisibilitySettings: readonly menuVisibilityType[],
  menuType: MenuTypeEnum,
): boolean => {
  return menuVisibilitySettings.some((setting) => setting.menuType === menuType && setting.isHidden);
};
